function validNumber(value) {
    return typeof value === 'number' && Number.isFinite(value) && value >= 0;
}

export function runtimeMiB(value) {
    return validNumber(value) ? (value / (1024 * 1024)).toFixed(1) + ' MiB' : '暂无数据';
}

export function runtimeCount(value) {
    return validNumber(value) && Number.isInteger(value) ? String(value) : '—';
}

export function runtimeUptime(value) {
    if (!validNumber(value)) return '暂无数据';
    const minutes = Math.floor(value / 60000);
    if (!minutes) return '不足 1 分钟';
    const days = Math.floor(minutes / 1440);
    const hours = Math.floor(minutes / 60) % 24;
    const remainder = minutes % 60;
    return (days ? days + ' 天 ' : '') + (hours ? hours + ' 小时 ' : '') + remainder + ' 分钟';
}
